import * as yup from 'yup';

import { FieldProxy } from '../components/ArtifactForm/ArtifactForm.fields';

import { OrientacaoNarrativeWidget } from './Orientacoes.widgets';

const OrientacoesForm = [
  FieldProxy({
    name: 'narrative',
    label: 'Orientação médica',
    widget: OrientacaoNarrativeWidget,
    validator: yup
      .string()
      .required('Por favor, preencha a orientação para continuar'),
    getValue: fhirData => {
      const carePlan = fhirData as fhir4.CarePlan;

      return carePlan.text?.div || '';
    },
    setValue: (resource, value) => ({
      ...(resource as fhir4.CarePlan),
      text: {
        status: 'additional',
        div: value,
      },
    }),
    unsetValue: resource => ({
      ...(resource as fhir4.CarePlan),
      text: undefined,
    }),
  }),
];

export default OrientacoesForm;
